import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import {
  openResponsePhraseEdit,
  openResponsePhraseView,
} from "../../store/reducers/plantels/responsePhrases.reducer";
import { getResponsePhraseByIdThunk } from "../../store/reducers/plantels/plantels.thunks";

const ResponsePhrasesActions = ({ phrase }) => {
  const dispatch = useDispatch();

  const handleView = () => {
    dispatch(openResponsePhraseView());
    dispatch(getResponsePhraseByIdThunk(phrase.id));
  };

  const handleEdit = () => {
    dispatch(openResponsePhraseEdit(phrase));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>
      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        {/* <li>
            <button
              className={`${itemClass} ${phrase.is_active ? "text-danger" : "text-success"}`}
              onClick={() => console.log("Toggle clicked")}
            >
              <Icon
                icon={
                  phrase.is_active
                    ? "mdi:toggle-switch-off-outline"
                    : "mdi:toggle-switch-outline"
                }
                width="18"
              />
              <span>{phrase.is_active ? "Desactivar" : "Activar"}</span>
            </button>
          </li> */}
      </ul>
    </div>
  );
};

export default ResponsePhrasesActions;
